import { i18nInstance } from '../../i18n';

// from cents to dollar
export const fromCents = (value = 0) => value / 100;

// from dollar to cents
export const toCents = (value: number) => Math.floor(value * 100);

// from cents to dollar with locale
export const fromCentsWithLocale = (value: number, currency: string) => {
  return fromCents(value).toLocaleString(i18nInstance.language, { style: 'currency', currency });
};
